import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCompensationPlan,
  IconPresentation
} from '../../styles/Icons';

import {
  HeaderIcon,
  ResourcesBody,
  ResourcesContainer,
  ResourcesHeader,
  Title
} from './ResourcesStyled';
import { FooterText } from '../../styles/FontStyles';

export const Resources = () => {
  const { t } = useTranslation('resources');
  return (
    <AnimatedDashboard zoom>
      <PageTitle>{t('resources')}</PageTitle>
      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconPresentation />
            </Icon>
          </HeaderIcon>

          <Title>{t('presentation')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/EN_Travelution_Presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution presentation ( ENG 🏴󠁧󠁢󠁥󠁮󠁧󠁿)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/EN_GetRevolution presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>GetRevolution presentation ( ENG 🏴󠁧󠁢󠁥󠁮󠁧󠁿)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/HU_Travelution prezentáció.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution prezentáció ( HU 🇭🇺)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/HU_GetRevolution prezentáció.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>GetRevolution prezentáció ( HU 🇭🇺)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/ESP_Travelution Presentacion.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution presentacion ( ESP 🇪🇸)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/CZ_Travelution Prezentace.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution prezentace ( CZ 🇨🇿)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/DE_Travelution Präsentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution präsentation ( DE 🇩🇪)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/RO_Travelution prezentare.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution prezentare ( RO 🇷🇴)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SLO_predstavitev.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution predstavitev ( SLO 🇸🇮)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SRB_Travelution prezentacija.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution prezentacija ( SRB 🇷🇸)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SRB_презентација.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution презентација ( SRB 🇷🇸)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/BG_представяне.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution представяне ( BG 🇧🇬)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/RU_presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution презентация ( RU 🇷🇺)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/UA_презентація.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution презентація ( UA 🇺🇦)</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>

      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconCompensationPlan />
            </Icon>
          </HeaderIcon>

          <Title>Compensation Plan</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/EN_Travelution_Compensation Plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution compensation plan ( ENG 🏴󠁧󠁢󠁥󠁮󠁧󠁿)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/EN_GetRevolution Compensation plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>GetRevolution compensation plan ( ENG 🏴󠁧󠁢󠁥󠁮󠁧󠁿)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/HU_Kompenzációs Terv.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution kompenzációs ter ( HU 🇭🇺)</li>
          </a>
        </ResourcesBody>

        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/ESP_Plan de Compensacion.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution plan de compensacion ( ESP 🇪🇸)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/CZ_Kompenzacni plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution kompenzacni plan ( CZ 🇨🇿)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/DE_Vergütungsplan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution vergütungsplan ( DE 🇩🇪)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/RO_Plan_de compensare.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution plan de compensare ( RO 🇷🇴)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SLO_načrt nadomestil.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution načrt nadomestil ( SLO 🇸🇮)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SRB_Kompenzacioni plan.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution kompenzacioni plan ( SRB 🇷🇸)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/SRB_Компензациониплан.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution kомпензациони план ( SRB 🇷🇸)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/BG_компенсации.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution компенсации план ( BG 🇧🇬)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/RU_план компенсации.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution план компенсации ( RU 🇷🇺)</li>
          </a>
        </ResourcesBody>
        <ResourcesBody>
          <a
            href='https://resources.travelutionclub.com/presentations/UA_план компенсації.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Travelution план компенсації ( UA 🇺🇦)</li>
          </a>
        </ResourcesBody>

        <div style={{ fontWeight: 'bold', fontSize: 12, marginTop: 30 }}>
          Disclaimer
        </div>
        <FooterText style={{ fontSize: 11 }}>
          The documents provided in this section, including presentations and
          compensation plans, are available in multiple languages for your
          convenience. Please note that the English version is the official and
          original reference. While we strive to ensure that all translations
          accurately reflect the content of the English version, the company
          cannot guarantee the accuracy, completeness, or reliability of
          translated versions. In the event of any discrepancies or differences
          in interpretation, the English version shall prevail, and the company
          assumes no responsibility for errors or misinterpretations arising
          from translations.
        </FooterText>
      </ResourcesContainer>
    </AnimatedDashboard>
  );
};
